<!-- 任务模板 -->
<template>
    <div ref="scrollableDiv">
        <!-- 模板列表 -->
        <div class="container card">
            <!-- 菜单栏 -->
            <el-row style="margin-top: 25px; margin-bottom: 25px" type="flex" justify="space-between" align="middle">
                <!-- 搜索 -->
                <el-col :span="12">
                    <el-row type="flex" justify="start" align="middle">
                        <el-input v-model="taskModelFindform.templateName" placeholder="任务模板 - 支持模糊查询" clearable style="width: 200px"> </el-input>
                        <el-button type="primary" style="margin-left: 15px" @click="taskModelFind">查询</el-button>
                    </el-row>
                </el-col>
                <!-- 任务操作 -->
                <el-col :span="8">
                    <el-row type="flex" justify="end" align="middle">
                        <span style="color: white">
                            {{ nowpatch }}
                        </span>
                        <el-button type="primary" style="margin-left: 15px" @click="newtaskform">新建任务</el-button>
                    </el-row>
                </el-col>
            </el-row>
            <!-- 数据表格 -->
            <div class="eltable">
                <el-table :data="taskList" :header-row-style="{ color: 'white' }" style="border-radius: 12px" stripe border>
                    <!-- 序号列 -->
                    <el-table-column label="序号" header-align="center" align="center" width="80%">
                        <template v-slot="scope">
                            <span>{{ scope.$index + 1 }}</span>
                        </template>
                    </el-table-column>

                    <!-- 模板名称 -->
                    <el-table-column label="模板名称" header-align="center" align="center" sortable prop="templateName">
                        <template v-slot="scope">
                            <span>{{ scope.row.templateName }} </span>
                        </template>
                    </el-table-column>

                    <!-- 创建人 -->
                    <el-table-column header-align="center" align="center" label="创建人" width="100px">
                        <template v-slot="scope">
                            {{ scope.row.createdBy }}
                        </template>
                    </el-table-column>

                    <!-- 当前状态 -->
                    <el-table-column v-if="false" header-align="center" align="center" label="当前状态">
                        <template v-slot="scope">
                            <!-- <el-button style="width: 80px" v-if="scope.row.accountStatus == 0" type="success">{{
                                    scope.row.accountStatusStr }}</el-button>
                                <el-button style="width: 80px" v-if="scope.row.accountStatus == 1" type="info">{{
                                    scope.row.accountStatusStr }}</el-button> -->
                            后端添加,当前的发布状态
                            {{ scope.row }}
                        </template>
                    </el-table-column>

                    <!-- 审核人数 -->
                    <el-table-column label="审核员及任务比例" header-align="center" align="center">
                        <template v-slot="scope">
                            <el-button link type="primary" @click="showtaskusers(scope.row)">查看详情（{{ JSON.parse(scope.row.operator).ratioList.length }}人）</el-button>
                        </template>
                    </el-table-column>

                    <!-- 筛选条件 -->
                    <el-table-column label="筛选条件" header-align="center" align="center">
                        <template v-slot="scope">
                            <el-button link type="primary" @click="showtaskfilterword(scope.row)"> 查看详情 </el-button>
                        </template>
                    </el-table-column>

                    <!-- 操作列 -->
                    <el-table-column label="操作" header-align="center" align="center" width="200px">
                        <template v-slot="scope">
                            <el-button type="primary" @click="tsakstart(scope.row, 0)"> 发布 </el-button>
                            <el-button type="danger" @click="tasktemplatedel(scope.row)"> 删除 </el-button>
                        </template>
                    </el-table-column>
                    <!-- 是否自动发布 -->
                    <el-table-column header-align="center" align="center" label="自动发布" width="100px">
                        <template v-slot="scope">
                            <el-switch
                                v-model="scope.row.isAutoRun"
                                inline-prompt
                                style="--el-switch-on-color: #13ce66; --el-switch-off-color: #ff4949"
                                active-text="启动"
                                :active-value="1"
                                :inactive-value="0"
                                @change="setauto(scope.row)"
                                inactive-text="禁用" />
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 分页器 -->
                <el-pagination
                    :currentPage="current"
                    :page-size="pageSize"
                    :page-sizes="[10, 50, 100]"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="allpages"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    style="display: flex; justify-content: center; margin-top: 20px" />
            </div>
        </div>

        <!-- 固定按钮 -->
        <FixedButtons @scroll-to-top="scrollToTop" />

        <!-- 弹窗部分 -->
        <div>
            <!-- 新建/编辑任务 -->
            <el-dialog v-model="taskcreateDialogshow" :title="DialogTitle_istaskCreate + '模板'" center align-center draggable :close-on-click-modal="false" @close="resetForm">
                <div>
                    <el-scrollbar max-height="600px">
                        <el-form ref="createTaskFormRef" :model="createTaskForm" :rules="rules" label-width="auto" label-position="top" :size="formSize" status-icon>
                            <!-- 任务名称 -->
                            <el-form-item label="" prop="templateName">
                                <el-divider content-position="left"><span style="color: red">* </span>任务名称</el-divider>
                                <el-input v-model="createTaskForm.templateName" placeholder="请输入" style="width: 220px" />
                            </el-form-item>
                            <!-- 修改审核人员比例 -->
                            <el-form-item label="" prop="operator">
                                <el-divider content-position="left"><span style="color: red">* </span>审核员</el-divider>
                                <div style="display: flex; gap: 10px; margin-right: 50px; margin-bottom: 15px" v-for="(operator, index) in createTaskForm.operator" :key="index">
                                    <el-input v-if="DialogTitle_istaskCreate != '编辑'" v-model="nickNameList[operator.loginId]" :disabled="true" style="width: 200px" />
                                    <el-input v-else v-model="operator.nickName" :disabled="true" style="width: 200px" />
                                    <el-input-number v-model="operator.ratio" @change="1" :min="1" :max="10" />
                                    <el-button type="danger" @click.prevent="removeUser(operator)">删除</el-button>
                                </div>
                            </el-form-item>
                            <!-- 添加审核人员 -->
                            <el-form-item>
                                <el-button type="primary" @click="showUseraddDialog">添加</el-button>
                            </el-form-item>
                            <!-- 添加屏蔽词 -->
                            <el-form-item label="" prop="descDescribeMask">
                                <el-divider content-position="left"> 屏蔽词 </el-divider>
                                <el-tag
                                    v-for="(keyword, index) in createTaskForm.descDescribeMask"
                                    :key="keyword"
                                    closable
                                    type="primary"
                                    style="margin-right: 5px; margin-bottom: 8px"
                                    @close="outkeywordMask(index)">
                                    {{ keyword }}
                                </el-tag>
                            </el-form-item>
                            <!-- 需要显示注册 emit -->
                            <el-button type="primary" @click="addkeywordtotaskMsak">添加</el-button>
                            <!-- 添加筛选词 -->
                            <el-form-item label="" prop="descDescribe">
                                <el-divider content-position="left"> 筛选词 </el-divider>
                                <el-tag
                                    v-for="(keyword, index) in createTaskForm.descDescribe"
                                    :key="keyword"
                                    closable
                                    type="primary"
                                    style="margin-right: 5px; margin-bottom: 8px"
                                    @close="outkeyword(index)">
                                    {{ keyword }}
                                </el-tag>
                            </el-form-item>
                            <!-- 需要显示注册 emit -->
                            <el-button type="primary" @click="addkeywordtotask">添加</el-button>
                            <!-- 配置等级 -->
                            <el-form-item label="" prop="platform">
                                <el-divider content-position="left"><span style="color: red">* </span>平台及等级</el-divider>
                                <div v-for="(operator, index) in createTaskForm.platform" :key="index" style="margin-bottom: 15px">
                                    <div style="display: flex; width: 100%; margin-bottom: 10px; margin-right: 15px">
                                        <!-- 平台 -->
                                        <el-button @click="getPlatformLevel()" type="" style="flex: 1; margin-right: 10px; width: 225px">
                                            {{ operator.name }}
                                        </el-button>
                                        <!-- 等级选择器 -->
                                        <el-select
                                            v-model="operator.level"
                                            placeholder="选择"
                                            filterable
                                            clearable
                                            multiple
                                            style="flex: 4; min-width: 200px; margin-right: 10px"
                                            @click="1">
                                            <el-option v-for="option in levelindexList[index]" :key="option.id" :label="option.levelName" :value="option.levelName" />
                                        </el-select>
                                        <!-- 删除按钮 -->
                                        <el-button type="danger" @click.prevent="removePlatform(operator)" style="flex: 1"> 删除 </el-button>
                                    </div>
                                </div>
                            </el-form-item>
                            <!-- 添加平台 -->
                            <el-form-item style="display: flex; align-items: center">
                                <el-select
                                    v-model="tempaddplatform"
                                    placeholder="选择平台"
                                    filterable
                                    clearable
                                    style="flex: 1; margin-right: 10px; max-width: 220px"
                                    @change="addplatform">
                                    <el-option v-for="option in platformListresp.data" :key="option.id" :label="option.platformName" :value="option.platformName" />
                                </el-select>
                            </el-form-item>
                            <!-- 添加型号及内存 -->
                            <el-form-item label="" prop="productInfo">
                                <el-divider content-position="left"> 型号及内存 </el-divider>
                            </el-form-item>
                            <div style="margin-bottom: 20px">
                                <el-radio v-model="switchValue" label="1">筛选机型</el-radio>
                                <el-radio v-model="switchValue" label="0">屏蔽机型</el-radio>
                            </div>
                            <el-scrollbar max-height="150px">
                                <div v-for="(keyword, keywordindex) in createTaskForm.productInfo" :key="keyword">
                                    <span v-if="false">{{ keywordindex }}</span>
                                    <div>
                                        <el-tag
                                            v-for="(modellevel, index) in keyword.ramStorage"
                                            :key="modellevel"
                                            closable
                                            type="primary"
                                            style="margin-right: 5px; margin-bottom: 8px"
                                            @close="outmodellevel([keyword.modelId, index], 0)">
                                            {{ modelnameList[keyword.modelId] }}&emsp;{{ modellevel }}
                                        </el-tag>
                                    </div>
                                    <div class="model">
                                        <el-tag closable type="primary" style="margin-right: 5px; margin-bottom: 8px" @close="outmodellevel(keyword.modelId, 1)">
                                            {{ modelnameList[keyword.modelId] ? modelnameList[keyword.modelId] : keyword.modelName }}
                                        </el-tag>
                                    </div>
                                </div>
                            </el-scrollbar>
                            <!-- 选择品牌 -->
                            <el-form-item style="display: flex; align-items: center">
                                <el-select
                                    v-model="tempbrandSelect"
                                    placeholder="选择品牌"
                                    filterable
                                    clearable
                                    style="flex: 1; margin-right: 10px; max-width: 220px"
                                    @change="addModelLevelDialog">
                                    <el-option v-for="option in sysPlatformBrandList" :key="option.id" :label="option.brandName" :value="option.id" />
                                </el-select>
                            </el-form-item>
                            <!-- 选择数字成色 -->
                            <el-form-item prop="quality">
                                <el-divider content-position="left"> 选择成色 </el-divider>
                                <div>
                                    <div style="display: flex; margin-bottom: 5px" v-for="option in conditionList" :key="option">
                                        <!-- 数字成色 -->
                                        <el-check-tag
                                            style="width: 60px; margin-right: 12px; display: flex; justify-content: center"
                                            :checked="isNumOptionChecked(option)"
                                            @change="handleNumTagChange(option)"
                                            type="success"
                                            size="large">
                                            {{ option }}
                                        </el-check-tag>
                                        <!-- 字母成色 -->
                                        <div style="display: flex">
                                            <el-check-tag
                                                v-for="alphaoption in alphalevelList"
                                                :key="alphaoption"
                                                style="width: 60px; margin-right: 12px; display: flex; justify-content: center"
                                                :checked="isAlphaOptionChecked(option, alphaoption)"
                                                @change="handleAlphaTagChange(option, alphaoption)"
                                                type="primary"
                                                size="large">
                                                {{ alphaoption }}
                                            </el-check-tag>
                                        </div>
                                    </div>
                                </div>
                            </el-form-item>
                        </el-form>
                        ??{{ createTaskForm }}??
                    </el-scrollbar>
                </div>

                <template #footer>
                    <div class="dialog-footer">
                        <el-button v-if="DialogTitle_istaskCreate == '编辑'" @click="backdetail" type="">返回</el-button>
                        <el-button v-else @click="resetForm" type="info">全部重置</el-button>
                        <el-button v-if="DialogTitle_istaskCreate == '编辑'" type="primary" @click="tempshow">保存</el-button>
                        <el-button v-else type="primary" @click="submitForm">{{ DialogTitle_istaskCreate }}</el-button>
                    </div>
                </template>
            </el-dialog>

            <!-- 查看模板详情 -->
            <el-dialog title="筛选条件详情" v-model="showtaskfilterworddialogshow" :draggable="true">
                <el-scrollbar height="600px">
                    <el-collapse v-model="activeNames">
                        <el-collapse-item title="关键词" name="1">
                            <div v-for="i in taskfilterwordlist.descDescribe" :key="i">
                                <div v-if="i.status == 1">
                                    <el-tag style="margin-right: 5px; margin-bottom: 5px" type="primary" v-for="item in i.desc" :key="item">
                                        <div>屏蔽词-{{ item }}</div>
                                    </el-tag>
                                </div>
                                <div v-if="i.status == 0">
                                    <el-tag style="margin-right: 5px; margin-bottom: 5px" type="primary" v-for="item in i.desc" :key="item">
                                        <div>筛选词-{{ item }}</div>
                                    </el-tag>
                                </div>
                            </div>
                        </el-collapse-item>
                        <el-collapse-item title="成色" name="2">
                            <div>
                                <el-tag style="margin-right: 5px; margin-bottom: 5px" type="primary" v-for="item in taskfilterwordlist.quality" :key="item">
                                    {{ item }}
                                </el-tag>
                            </div>
                        </el-collapse-item>
                        <el-collapse-item title="平台" name="3">
                            <el-collapse-item :title="i.name" :name="i.name" v-for="i in taskfilterwordlist.platform" :key="i" style="margin-left: 40px">
                                <el-tag v-for="j in i.level" :key="j" style="margin-right: 5px; margin-bottom: 5px" type="primary">
                                    {{ j }}
                                </el-tag>
                            </el-collapse-item>
                        </el-collapse-item>
                        <el-collapse-item title="型号" name="4">
                            <el-collapse-item :title="i.modelName" :name="i.modelName" v-for="i in productInfoDict.ramStorageInfo" :key="i" style="margin-left: 40px">
                                <div v-if="i.ramStorage">
                                    <el-tag v-for="j in i.ramStorage" :key="j" style="margin-right: 5px; margin-bottom: 5px" type="primary"> {{ i.modelName }} {{ j }} </el-tag>
                                </div>
                            </el-collapse-item>
                        </el-collapse-item>
                    </el-collapse>
                </el-scrollbar>
                <div>任务详情响应: {{ wwe }}</div>
                <div>taskfilterwordlist：{{ taskfilterwordlist }}</div>
                <template #footer>
                    <el-button type="primary" @click="editTask"> 编辑 </el-button>
                    <el-button @click="backshowtaskfilterworddialogshow"> 返回 </el-button>
                </template>
            </el-dialog>

            <!-- 选择审核人员 -->
            <el-dialog title="添加审核人员" v-model="chooseuserDialogshow" width="40%" :close-on-click-modal="false" :draggable="true" :modal="false">
                <checkeraddView ref="checkeraddViewRef" @listenuseradd="addChecker"></checkeraddView>
            </el-dialog>

            <!-- 显示进度条 -->
            <el-dialog
                title="正在计算任务进度..."
                v-model="showprogressDialogshow"
                :close-on-click-modal="false"
                :draggable="true"
                :close-on-press-escape="false"
                :show-close="false">
                <el-table>
                    <!-- 可以在这里插入进度条相关的数据，若需要 -->
                </el-table>
                <!-- 动态更新的进度条 -->
                <div>
                    符合条件总数:<el-progress :text-inside="true" :stroke-width="26" :percentage="progress1"></el-progress> 成色判断:<el-progress
                        :text-inside="true"
                        :stroke-width="26"
                        :percentage="progress2"
                        status="success"></el-progress>
                    转转估价:<el-progress :text-inside="true" :stroke-width="26" :percentage="progress3" status="warning"></el-progress> 拍机堂估价:<el-progress
                        :text-inside="true"
                        :stroke-width="26"
                        :percentage="progress4"
                        status="exception"></el-progress>
                </div>
                <div v-if="allProgressComplete">
                    <el-button type="primary" @click="exitTask">完成 !</el-button>
                    <el-button type="info" @click="exitTask">后台计算</el-button>
                </div>
            </el-dialog>

            <!-- 显示审核人员及任务比例 -->
            <el-dialog title="审核人员及任务比例" v-model="showtaskusersdialogshow">
                <div>
                    <div style="width: 100%; height: 30px; background-color: rgb(235, 238, 245); margin-bottom: 12px; display: flex; flex-direction: row; align-items: center">
                        <!-- 审核人员数 -- 占比方块 -->
                        <div
                            v-for="item in userlist"
                            :key="item.nickName"
                            :style="{
                                height: '100%',
                                width: ratioString(item.ratio / totalRatio(userlist)),
                                backgroundColor: generateRandomColor(item),
                                marginRight: '2px',
                                display: 'flex',
                            }"></div>
                    </div>
                    <div v-for="item in userlist" :key="item.nickName" label-position="right" style="margin-bottom: 6px">
                        <el-form-item>
                            <span style="min-width: 40px">
                                {{ item.nickName }}
                            </span>
                            <span style="margin-left: 12px"> {{ (item.ratio / totalRatio(userlist)) * 100 }}% </span>
                            <div
                                :style="{
                                    width: '24px',
                                    height: '40%',
                                    backgroundColor: item.color,
                                    marginLeft: '12px',
                                }"></div>
                        </el-form-item>
                    </div>
                </div>
            </el-dialog>

            <!-- 屏蔽词-->
            <el-dialog title="添加屏蔽词" v-model="showtaskkeywordadddialogshowMask" :close-on-click-modal="false" :draggable="true" :modal="false" width="500px">
                <keywordAddtotaskViewMask ref="keywordAddtotaskViewRef" @listenkeywordaddMask="addkeywordtoformMask"> </keywordAddtotaskViewMask>
            </el-dialog>

            <!-- 添加筛选词-->
            <el-dialog title="添加筛选词" v-model="showtaskkeywordadddialogshow" :close-on-click-modal="false" :draggable="true" :modal="false" width="500px">
                <keywordAddtotaskView ref="keywordAddtotaskViewRef" @listenkeywordadd="addkeywordtoform"> </keywordAddtotaskView>
            </el-dialog>

            <!-- 添加型号和内存 -->
            <el-dialog title="添加型号和内存" v-model="addmodelleveldialogshow" :close-on-click-modal="false" :draggable="true" :modal="false" style="width: 600px">
                <modellevelAddtotaskView
                    ref="modellevelAddtotaskViewRef"
                    :brandIdselect="tempbrandSelect"
                    @listenmodelleveladd="modelleveladd"
                    @listenmodellevelshowdialog="modellevelshowdialog"
                    @modelCheck="modellevelAlladd" />
            </el-dialog>

            <!-- 发布 -->
            <el-dialog title="发布" v-model="dialogRelease">
                <el-form :model="formRelease">
                    <el-form-item label="模版名称">
                        <div>{{ templateName }}</div>
                    </el-form-item>
                    <el-form-item label="任务">
                        <el-input v-model="formRelease.taskName" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogRelease = false">取 消</el-button>
                    <el-button type="primary" @click="dialogReleaseHandle">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import FixedButtons from "@/components/FixedButtons.vue";
    import checkeraddView from "@/views/details/checkeraddView.vue";
    import keywordAddtotaskView from "@/views/details/keywordAddtotaskView.vue";
    import keywordAddtotaskViewMask from "@/views/details/keywordAddtotaskViewMask.vue";
    import modellevelAddtotaskView from "@/views/details/modellevelAddtotaskView.vue";
    import axios from "axios";
    import swal from "sweetalert2";

    export default {
        name: "PracticalTableView",
        components: {
            FixedButtons,
            checkeraddView,
            keywordAddtotaskView,
            modellevelAddtotaskView,
            keywordAddtotaskViewMask,
        },

        data() {
            return {
                // 选中的任务
                rowSelectedList: [],

                wwe: null,

                activeNames: ["1", "2", "3"],
                gettsakModelselectinfoURL: "/api/biddingTaskTemplate/getTemplateInfo", //{templateId}
                tagColors: ["success", "primary", "warning", "danger", "success"],
                // 进度条
                progress1: 0,
                progress2: 0,
                progress3: 0,
                progress4: 0,
                intervalId: null,

                platformList: [],
                sysPlatformBrandList: [],
                sysPlatformModelList: [],
                conditionList: [],
                alphalevelList: ["S", "A", "B", "C", "D"],
                taskList: [],
                taskfilterwordlist: {},
                // 筛选出的商品
                productInfoDict: {},

                // 弹窗状态
                DialogTitle_istaskCreate: "创建模板",
                taskcreateDialogshow: false,
                chooseuserDialogshow: false,
                showprogressDialogshow: false,
                showtaskusersdialogshow: false,
                showtaskfilterworddialogshow: false,
                showtaskkeywordadddialogshow: false,
                showtaskkeywordadddialogshowMask: false,
                addmodelleveldialogshow: false,
                dialogRelease: false,
                templateName: "",
                taskTemplateId: "",
                formRelease: {
                    taskName: "",
                    type: 0,
                },

                flag: 0,
                num: null,

                testshow: process.env.VUE_APP_SHOW === "true",
                tsakstartURL: "/api/biddingTask/createTask",
                tasktemplatedelURL: "/api/biddingTaskTemplate/delBiddingTaskTemplate",
                // 下拉框初始化
                conditionlevelInitURL: "/api/PlatformDesc/getConditionInit",
                syspStandardModel: "/api/ProductModel/init",
                platformURL: "/api/systemPlatformInfo/platForm/init",
                accountURL: "/api/externalAccount/queryExternalAccount",
                insertURL: "/api/externalAccount/insertCurrentUserExternalAccount",
                deleteURL: "/api/externalAccount/deletedCurrentUserExternalAccount",
                updateURL: "/api/externalAccount/update",
                sysBrand: "/api/ProductBrand/init",
                platformlevelURL: "/api/level/getLevelByPlatform",
                syspStandardBrandURL: "/api/ProductBrand/getBrand",
                submittsakmodelURL: "/api/biddingTaskTemplate/createBiddingTaskTemplate",
                setautoURL: "/api/biddingTaskTemplate/setAutoRun",

                current: 1,
                pageSize: 50,

                // 任务查询
                platformListresp: { data: [] },
                taskModelFindform: {
                    templateName: "",
                },
                aa: "",
                levelindexList: [],

                tempaddplatform: null,
                tempbrandSelect: null,

                // el 表格
                tableData: [],
                search: "",

                nickNameList: {},
                modelnameList: {},
                isAll: false,
                modelnameAll: [],

                scrollableDiv: null,
                currentPage: 1, // 当前页码
                itemsPerPage: 20, // 每页显示条目数
                allpages: 1, // 总页数
                accountTypeId: "", //平台ID

                formSize: "default",
                createTaskFormRef: null,
                tempbrandSelectRef: null,
                createTaskForm: {
                    productInfo: [],
                    quality: [],
                    templateName: "",
                    operator: [],
                    descDescribe: [],
                    descDescribeMask: [],
                    platform: [],
                    status: 1, // 0 为屏蔽模式
                },
                switchValue: "1",

                rules: {
                    templateName: [
                        {
                            required: true,
                            message: "未填写任务名称!",
                            trigger: "blur",
                        },
                    ],
                    operator: [
                        {
                            required: true,
                            message: "未选择审核员!",
                            trigger: "change",
                        },
                    ],
                    platform: [
                        {
                            required: true,
                            message: "请选择平台!",
                            trigger: "change",
                        },
                    ],
                },
            };
        },

        // 进入页面时就获取数据
        beforeRouteEnter(to, from, next) {
            next((vm) => {});
        },
        methods: {
            // 自动发布状态变更
            setauto(row) {
                axios
                    .put(
                        this.setautoURL,
                        {},
                        {
                            params: {
                                templateId: row.id,
                                isAutoRun: row.isAutoRun,
                            },
                            headers: {
                                satoken: localStorage.sa,
                            },
                        }
                    )
                    .then((res) => {
                        if (res.data.success) {
                            this.$message.success(res.data);
                        } else {
                            this.$message.error(res.data);
                        }
                    });
            },
            // 获取平台对应的等级
            getPlatformLevel() {
                this.$message.info("😍");
            },
            tempshow() {
                this.$message.info("😍");
            },
            // 返回
            backshowtaskfilterworddialogshow() {
                this.showtaskfilterworddialogshow = false;
            },
            // 编辑-修改任务模板
            editTask() {
                this.$message.warning("编辑功能暂未开放");
                this.DialogTitle_istaskCreate = "编辑";
                this.taskcreateDialogshow = true;
                // 先要等待 taskoptionInit 里面的 getmenuInit 里面的 axios 响应 回来后再执行 下面的代码
                this.createTaskForm.platform = this.taskfilterwordlist.platform;
                this.createTaskForm.templateName = this.taskfilterwordlist.templateName;
                this.createTaskForm.operator = this.taskfilterwordlist.operator;
                this.taskoptionInit();
                this.createTaskForm.quality = this.taskfilterwordlist.quality;
                console.log("回显", this.taskfilterwordlist.quality);

                this.createTaskForm.descDescribeMask = this.taskfilterwordlist.descDescribe.filter((item) => item.status === 1)[0].desc;
                this.createTaskForm.descDescribe = this.taskfilterwordlist.descDescribe.filter((item) => item.status === 0)[0].desc;
                this.initplatformOptions();
            },
            // 修改模板时,下拉框初始化
            initplatformOptions() {
                for (let item of this.createTaskForm.platform) {
                    this.getgradelevel(item.name);
                }
            },
            // 自定义彩虹条
            generateRandomColor(item) {
                const r = Math.floor(Math.random() * 256);
                const g = Math.floor(Math.random() * 256);
                const b = Math.floor(Math.random() * 256);
                item.color = `rgb(${r}, ${g}, ${b})`;
                return `rgb(${r}, ${g}, ${b})`; // 返回RGB颜色字符串
            },

            ratioString(percent) {
                return String(percent) * 100 + "%";
            },

            totalRatio(userlist) {
                return userlist.reduce((sum, item) => sum + item.ratio, 0);
            },
            // 请求任务详情
            gettsakModelselectinfo(templateId) {
                axios
                    .get(this.gettsakModelselectinfoURL + "/" + templateId, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                    })
                    .then((res) => {
                        if (res.data.success) {
                            this.taskfilterwordlist = JSON.parse(res.data.data.filter);
                            this.taskfilterwordlist.templateName = res.data.data.templateName;
                            this.taskfilterwordlist.operator = JSON.parse(res.data.data.operator).ratioList;
                            this.productInfoDict = this.taskfilterwordlist.productInfo;
                            this.wwe = res.data.data;
                        } else {
                            this.$message.error("服务端出现错误..");
                        }
                    });
            },
            // 删除模板
            tasktemplatedel(row) {
                this.$confirm("确认删除该条任务吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        axios
                            .delete(this.tasktemplatedelURL + "/" + row.id, {
                                headers: {
                                    satoken: localStorage.sa,
                                },
                            })
                            .then((res) => {
                                if (res.data.success) {
                                    this.$message({
                                        type: "success",
                                        message: "删除成功!",
                                    });
                                    this.taskModelFind();
                                }
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除",
                        });
                    });
            },

            // 时间格式化
            zeroPadding(num, digit) {
                let zero = "";
                for (let i = 0; i < digit; i++) {
                    zero += "0";
                }
                return (zero + num).slice(-digit);
            },
            //发布任务
            dialogReleaseHandle() {
                if (this.formRelease.type == 0) {
                    // 单个发布
                    this.rowSelectedList = [
                        {
                            taskName: this.formRelease.taskName,
                            taskTemplateId: this.taskTemplateId,
                            patch: this.nowpatch,
                        },
                    ];
                } else {
                    // 多选发布
                    this.rowSelectedList = row;
                }
                axios
                    .post(this.tsakstartURL, this.rowSelectedList, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                    })
                    .then((res) => {
                        if (res.data.success) {
                            let failListHtml = "";
                            if (res.data.data.failList && Object.keys(res.data.data.failList).length > 0) {
                                for (const [key, value] of Object.entries(res.data.data.failList)) {
                                    value.forEach((item, index) => {
                                        failListHtml += `${item} &emsp;`;
                                    });
                                }
                            }

                            // 构建整个提示框的 HTML 内容
                            const contentHtml = `成功发布:&emsp;${res.data.data.successCount}&emsp;条<br>重复发布:&emsp;${res.data.data.failCount}&emsp;条<br>${failListHtml}`;
                            swal.fire({
                                icon: "warning",
                                title: `发布结果`,
                                html: contentHtml,
                                confirmButtonText: "好的",
                            });
                            this.dialogRelease = false;
                            // this.$message.success("操作成功!");
                        } else {
                            this.$message.error(res.data.message);
                        }
                    });
            },
            // 发布任务
            tsakstart(row, type) {
                this.dialogRelease = true;
                this.templateName = row.templateName;
                this.taskTemplateId = row.id;
                this.formRelease.type = type;
            },

            // 删除 型号 tag
            outmodellevel(index, type) {
                if (type == 0) {
                    this.createTaskForm.productInfo = this.createTaskForm.productInfo.map((item) => {
                        if (item.modelId === index[0]) {
                            item.ramStorage = item.ramStorage.filter((ramItem, ramIndex) => ramIndex !== index[1]);
                        }
                        return item;
                    });
                }
                if (type == 1) {
                    this.createTaskForm.productInfo = this.createTaskForm.productInfo.filter((item) => !(item.modelId === index && item.ramStorage === null));
                }
            },

            // 去重并排序
            dofilterandsort(data) {
                let map = new Map();

                data.forEach((item) => {
                    // 如果 ramStorage 是空数组，转换为 null
                    if (Array.isArray(item.ramStorage) && item.ramStorage.length === 0) {
                        item.ramStorage = null;
                    }

                    let existing = map.get(item.modelId);
                    if (existing) {
                        // 合并 ramStorage，去重（仅在 ramStorage 不为 null 时）
                        if (item.ramStorage !== null) {
                            // 确保 existing.ramStorage 和 item.ramStorage 都是有效数组
                            existing.ramStorage = [...new Set((existing.ramStorage || []).concat(item.ramStorage || []))];
                        }
                    } else {
                        // 第一次遇到该 modelId
                        map.set(item.modelId, item);
                    }
                });

                // 对结果进行排序并最终将空数组转换为 null
                const result = [...map.values()].sort((a, b) => {
                    // 直接按数字进行排序
                    return a.modelId - b.modelId;
                });

                // 将 ramStorage 是空数组的项转换为 null
                result.forEach((item) => {
                    if (Array.isArray(item.ramStorage) && item.ramStorage.length === 0) {
                        item.ramStorage = null;
                    }
                });

                return result;
            },

            // 正确请求后才显示弹窗--子组件传值
            modellevelshowdialog(val) {
                this.addmodelleveldialogshow = val;
            },

            // todo 型号内存添加
            modelleveladd(row, name) {
                this.createTaskForm.productInfo.push(row);
                this.createTaskForm.productInfo = this.dofilterandsort(this.createTaskForm.productInfo);
                this.modelnameList[row.modelId] = name;
            },

            //全选型号内存添加
            modellevelAlladd(row) {
                // this.createTaskForm.productInfo = row;
                this.createTaskForm.productInfo = [...this.createTaskForm.productInfo, ...row];
                // this.createTaskForm.productInfo = [...row];

                // this.createTaskForm.productInfo = this.dofilterandsort(this.createTaskForm.productInfo);
            },

            isNumOptionChecked(option) {
                for (var item of this.createTaskForm.quality) {
                    if (item.startsWith(String(option) + "-")) {
                        return true;
                    }
                }
                return false;
            },
            isAlphaOptionChecked(n, a) {
                return this.createTaskForm.quality.includes(String(n) + "-" + String(a));
            },
            //  数字成色选择
            handleNumTagChange(option) {
                if (this.isNumOptionChecked(option)) {
                    // 如果已经选中了，点击后取消选中
                    this.createTaskForm.quality = this.createTaskForm.quality.filter((item) => !item.startsWith(option));
                } else {
                    // 如果没有选中，点击后选中
                    for (let alpha of this.alphalevelList) {
                        this.createTaskForm.quality.push(String(option) + "-" + String(alpha));
                    }
                }
            },
            //  字母成色选择
            handleAlphaTagChange(numoption, option) {
                var _whole_quality = String(numoption) + "-" + String(option);
                if (this.createTaskForm.quality.includes(_whole_quality)) {
                    // 如果已经选中了，点击后取消选中
                    this.createTaskForm.quality = this.createTaskForm.quality.filter((item) => item !== _whole_quality);
                } else {
                    // 如果没有选中，点击后选中
                    this.createTaskForm.quality.push(_whole_quality);
                }
            },
            // 筛选品牌、型号、内存
            addModelLevelDialog(brandId) {
                if (brandId == null) {
                    return;
                }
                if (this.tempbrandSelect) {
                    this.addmodelleveldialogshow = true;
                    if (this.$refs.modellevelAddtotaskViewRef) {
                        this.$refs.modellevelAddtotaskViewRef.getmodellevel(brandId);
                    }
                } else {
                    this.$message.error("没有选择品牌!");
                }
            },
            test_addModelLevelDialog() {
                if (this.tempbrandSelect) {
                    this.tempbrandSelect = 52;
                    this.addmodelleveldialogshow = true;
                    if (this.$refs.modellevelAddtotaskViewRef) {
                        this.$refs.modellevelAddtotaskViewRef.getmodellevel();
                    }
                } else {
                    this.$message.error("没有选择品牌!");
                }
            },
            // 关闭 keyword tag
            outkeywordMask(index) {
                this.createTaskForm.descDescribeMask.splice(index, 1);
            },
            // 关闭 keyword tag
            outkeyword(index) {
                this.createTaskForm.descDescribe.splice(index, 1);
            },
            // 子传父
            addkeywordtoform(val) {
                this.aa = val;
                this.createTaskForm.descDescribe.push(val.descDescribe);
                this.createTaskForm.descDescribe = this.createTaskForm.descDescribe.filter((value, index, self) => {
                    // 通过查找该对象的 loginId 是否已存在，来去重
                    return index === self.findIndex((t) => t === value);
                });
            },
            addkeywordtoformMask(val) {
                this.aa = val;
                this.createTaskForm.descDescribeMask.push(val.descDescribe);
                this.createTaskForm.descDescribeMask = this.createTaskForm.descDescribeMask.filter((value, index, self) => {
                    // 通过查找该对象的 loginId 是否已存在，来去重
                    return index === self.findIndex((t) => t === value);
                });
            },
            // 添加屏蔽词
            addkeywordtotaskMsak() {
                this.showtaskkeywordadddialogshowMask = true;
            },
            // 添加筛选词
            addkeywordtotask() {
                this.showtaskkeywordadddialogshow = true;
            },
            // 获取平台对应等级
            getgradelevel(platformname) {
                if (platformname) {
                    axios
                        .get(this.platformlevelURL, {
                            headers: {
                                satoken: localStorage.sa,
                            },
                            params: {
                                platform: platformname,
                            },
                        })
                        .then((res) => {
                            this.levelindexList.push(res.data.data);
                            this.tempaddplatform = null;
                        });
                }
            },
            // 添加平台
            addplatform() {
                if (this.tempaddplatform) {
                    this.createTaskForm.platform.push({
                        name: this.tempaddplatform,
                    });
                    var tempLen1 = this.createTaskForm.platform.length;
                    // 去重
                    this.createTaskForm.platform = this.createTaskForm.platform.filter((value, index, self) => {
                        return index === self.findIndex((t) => t.name === value.name);
                    });
                    var tempLen2 = this.createTaskForm.platform.length;
                    if (tempLen1 == tempLen2) {
                        this.getgradelevel(this.tempaddplatform);
                    } else {
                        this.tempaddplatform = null;
                    }
                }
            },
            // 移除平台
            removePlatform(item) {
                var index = this.createTaskForm.platform.indexOf(item);
                if (index !== -1) {
                    this.createTaskForm.platform.splice(index, 1);
                    this.levelindexList.splice(index, 1);
                }
            },
            // 查看任务详情按钮
            showtaskfilterword(row) {
                this.showtaskfilterworddialogshow = true;
                this.gettsakModelselectinfo(row.id);
            },
            //显示任务的审核员
            showtaskusers(row) {
                this.showtaskusersdialogshow = true;
                this.userlist = JSON.parse(row.operator).ratioList;
            },
            // 关闭进度条弹框
            exitTask() {
                this.showprogressDialogshow = false;
            },
            startProgress() {
                // 设置一个定时器来动态更新进度条
                this.intervalId = setInterval(() => {
                    // 依次更新每个进度条的进度
                    if (this.progress1 < 100) this.progress1 += 1;
                    if (this.progress2 < 100) this.progress2 += 2;
                    if (this.progress3 < 100) this.progress3 += 3;
                    if (this.progress3 > 100) this.progress3 += -1;
                    if (this.progress4 < 100) this.progress4 += 1;

                    // 当所有进度条完成时，清除定时器
                    if (this.progress1 >= 100 && this.progress2 >= 100 && this.progress3 >= 100 && this.progress4 >= 100) {
                        clearInterval(this.intervalId);
                    }
                }, 100); // 每100ms更新一次进度
            },
            // 计算进度
            showprogress() {
                this.showprogressDialogshow = true;
            },
            // 查询模板
            taskModelFind() {
                // 构建URL
                const taskModelFindURL = `/api/biddingTaskTemplate/selectBiddingTaskTemplateByPage/${this.current}/${this.pageSize}`;

                axios
                    .get(taskModelFindURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            ...this.taskModelFindform,
                        },
                    })
                    .then((response) => {
                        this.taskList = response.data.data.result;
                        this.allpages = response.data.data.total;
                    })
                    .catch((error) => {
                        console.error("请求失败:", error);
                    });
            },
            // 获取全部成色
            getmenuInit() {
                try {
                    axios
                        .get(this.conditionlevelInitURL, {
                            headers: {
                                satoken: localStorage.sa,
                            },
                            params: {},
                        })
                        .then((res) => {
                            if (res.data.success) {
                                this.conditionList = res.data.data;
                            } else {
                                this.conditionList = ["99", "95", "9", "8", "7", "0"];
                            }
                            // 自动选中非0选项
                            let templist = [];
                            for (let numoption of this.conditionList.filter((item) => item !== "0")) {
                                for (let alphaoption of this.alphalevelList) {
                                    templist.push(numoption + "-" + alphaoption);
                                }
                            }
                            this.createTaskForm.quality = templist;
                        });
                } catch (error) {
                    this.data = error;
                    console.error("获取数据出错:", error);
                } finally {
                    this.loading = false;
                }
            },
            // 查询系统标准的品牌和机型初始化下拉框
            getSyspStandardModel(val) {
                axios
                    .get(this.syspStandardModel, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            pageNo: this.currentPage,
                            pageSize: this.itemsPerModelPage,
                            brandId: val ? val : this.isBrandId,
                        },
                    })
                    .then((res) => {
                        if (val) {
                            this.sysPlatformModelList = res.data.data.modelNameList;
                        } else {
                            this.sysPlatformModelList = res.data.data.modelNameList;
                        }
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            // 获取所有标准品牌
            getSyspStandardBrand() {
                axios
                    .get(this.syspStandardBrandURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                    })
                    .then((res) => {
                        this.aa = res;
                        if (res.data) {
                            this.sysPlatformBrandList = res.data.data;
                        }
                    })
                    .catch();
            },
            // 新建任务表单
            newtaskform() {
                this.DialogTitle_istaskCreate = "创建";
                this.taskcreateDialogshow = true;
                this.taskoptionInit();
            },
            //任务选项初始化
            taskoptionInit() {
                this.getSyspStandardModel();
                this.getSyspStandardBrand();
                this.getmenuInit();
            },
            // 新增审核员弹窗
            showUseraddDialog() {
                this.chooseuserDialogshow = true;
            },
            // 移除审核员
            removeUser(item) {
                var index = this.createTaskForm.operator.indexOf(item);
                if (index !== -1) {
                    this.createTaskForm.operator.splice(index, 1);
                }
            },
            // 添加审核员
            addChecker(user) {
                this.nickNameList[user.loginId] = user.nickName;
                this.createTaskForm.operator.push({
                    loginId: user.loginId,
                    ratio: 1,
                });
                // 基于 loginId 属性去重
                this.createTaskForm.operator = this.createTaskForm.operator.filter((value, index, self) => {
                    // 通过查找该对象的 loginId 是否已存在，来去重
                    return index === self.findIndex((t) => t.loginId === value.loginId);
                });
            },
            // 点击了 tab 标签
            nowtabInit() {
                this.taskModelFind();
                this.getplatformListresp();
            },
            // 获取所有平台
            getplatformListresp() {
                axios
                    .get(this.platformURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                    })
                    .then((response) => {
                        this.platformListresp = response.data;
                    })
                    .catch((error) => {
                        console.error("请求出错：", error);
                    });
            },
            // 页面顶部
            scrollToTop() {
                this.scrollableDiv.scrollTo({
                    top: 0,
                    behavior: "auto",
                });
            },
            // 改变条数
            handleSizeChange(val) {
                this.pageSize = val;
                this.taskModelFind();
            },
            //改变页数
            handleCurrentChange(val) {
                this.current = val;
                this.taskModelFind();
            },
            // 提交表单
            submitForm() {
                this.$refs.createTaskFormRef.validate((valid) => {
                    this.createTaskForm.productInfo.forEach((item) => {
                        delete item.modelName;
                    });
                    let productInfo = {};
                    productInfo.ramStorageInfo = this.createTaskForm.productInfo;
                    productInfo.status = Number(this.switchValue);
                    let params = {
                        productInfo: productInfo,
                        quality: this.createTaskForm.quality,
                        templateName: this.createTaskForm.templateName,
                        descDescribe: [],
                        platform: this.createTaskForm.platform,
                        operator: this.createTaskForm.operator,
                    };

                    let obj = {};
                    obj.desc = this.createTaskForm.descDescribe;
                    obj.status = 1;
                    params.descDescribe.push(obj);
                    let objMask = {};
                    objMask.desc = this.createTaskForm.descDescribeMask;
                    objMask.status = 0;
                    params.descDescribe.push(objMask);
                    if (valid) {
                        // alert("Form submitted!");
                        axios
                            .post(this.submittsakmodelURL, params, {
                                headers: {
                                    satoken: localStorage.sa,
                                },
                            })
                            .then((response) => {
                                if (response.data.success) {
                                    this.taskModelFind();
                                    this.$message.success("任务创建成功!");
                                    this.resetForm();
                                    this.taskcreateDialogshow = false;
                                } else {
                                    swal.fire({
                                        title: `${response.data.data}`,
                                        html: `任务创建失败`,
                                        icon: "error",
                                        showCancelButton: false,
                                        confirmButtonColor: "#3085d6",
                                        confirmButtonText: "确定",
                                    });
                                }
                            })
                            .catch((error) => {
                                console.error("Error:", error);
                            });
                    } else {
                        return false;
                    }
                });
            },
            // 测试
            test_submitForm() {
                this.$refs.createTaskFormRef.validate((valid) => {
                    // alert("Form submitted!");
                    axios
                        .post(
                            this.submittsakmodelURL,
                            {
                                templateName: "测试",
                                operator: [
                                    {
                                        loginId: "1805138726262358000",
                                        ratio: 2,
                                    },
                                    {
                                        loginId: "1805138726262358000",
                                        ratio: 3,
                                    },
                                    {
                                        loginId: "1805138726262358000",
                                        ratio: 5,
                                    },
                                ],
                                descDescribe: ["轻微", "严重"],
                                platform: [
                                    {
                                        name: "回收宝",
                                        level: ["C1", "C2"],
                                    },
                                    {
                                        name: "采货侠",
                                        level: ["C1", "C2"],
                                    },
                                ],
                                productInfo: [
                                    {
                                        brandId: 7,
                                        modelId: 8460,
                                        ramStorage: ["4G+64G", "8G+256G"],
                                    },
                                ],
                            },
                            {
                                headers: {
                                    satoken: localStorage.sa,
                                },
                            }
                        )
                        .then((response) => {
                            if (response.data.success) {
                                this.$message.success("任务创建成功!");
                            } else {
                                swal.fire({
                                    title: `${response.data.data}`,
                                    html: `任务创建失败`,
                                    icon: "error",
                                    showCancelButton: false,
                                    confirmButtonColor: "#3085d6",
                                    confirmButtonText: "确定",
                                });
                            }
                        })
                        .catch((error) => {
                            console.error("Error:", error);
                        });
                });
            },
            // 重置任务表单选项
            resetForm() {
                this.$refs.createTaskFormRef.resetFields();
                this.tempbrandSelect = null;
            },
            // 返回模板详情
            backdetail() {
                this.resetForm();
                this.taskcreateDialogshow = false;
            },
        },
        watch: {
            // 当弹窗显示时，启动进度条
            showprogressDialogshow(newVal) {
                if (newVal) {
                    // 重置进度条
                    this.progress1 = 0;
                    this.progress2 = 0;
                    this.progress3 = 0;
                    this.progress4 = 0;

                    // 启动进度条更新
                    this.startProgress();
                }
            },
        },
        computed: {
            // 计算是否所有进度条都已完成
            allProgressComplete() {
                return this.progress1 >= 100 && this.progress2 >= 100 && this.progress3 >= 100 && this.progress4 >= 100;
            },
            // 时间函数
            nowpatch() {
                const date = new Date();
                this.time = this.zeroPadding(date.getHours(), 2) + ":" + this.zeroPadding(date.getMinutes(), 2) + ":" + this.zeroPadding(date.getSeconds(), 2);
                this.date = this.zeroPadding(date.getFullYear(), 4) + "-" + this.zeroPadding(date.getMonth() + 1, 2) + "-" + this.zeroPadding(date.getDate(), 2);
                if (date.getMinutes() < 50 && date.getHours() <= 8) {
                    return this.zeroPadding(date.getFullYear(), 4) + this.zeroPadding(date.getMonth() + 1, 2) + this.zeroPadding(date.getDate() - 1, 2) + "_2";
                } else {
                    return this.zeroPadding(date.getFullYear(), 4) + this.zeroPadding(date.getMonth() + 1, 2) + this.zeroPadding(date.getDate(), 2) + "_2";
                }
            },
        },
        mounted() {},
        created() {},
    };
</script>

<style lang="scss" scoped>
    /* 表格样式*/
    .el-table {
        justify-content: center;
        --el-table-header-bg-color: rgb(107, 107, 107);
        --el-table-text-color: #000000;
        --el-table-border: 1px solid #ebeef5;
    }

    .addone {
        width: 100%;
        justify-content: center;
        display: flex;
        background-color: aliceblue;
        border-radius: 0 0 20px 20px;
    }

    ul {
        padding: 0;

        li {
            list-style-type: none;
            margin-bottom: 15px;
        }
    }

    .practical-table {
        width: 100%;
        padding: 20px 40px;
        overflow: auto;
    }

    .card {
        background-color: transparent;
        border: 1px solid transparent;
    }

    .form-control {
        background-color: #ded9d9;
        margin: 0;
    }

    .thead-dark {
        background-color: #585d6b;
        color: white;
    }

    .form-group {
        margin-bottom: 25px;
    }

    :deep(.tiptop) {
        position: relative;
    }

    :deep(.tiptop .el-icon) {
        color: #ffffff;
        position: absolute;
        top: -53px;
        left: 215px;
    }

    :deep(.el-pagination > .is-first) {
        color: #ffffff;
    }

    :deep(.el-pagination__goto) {
        color: #ffffff;
    }

    :deep(.el-pagination__classifier) {
        color: #ffffff;
    }

    :deep(.model .el-tag.is-closable) {
        background: yellow;
    }

    :deep(.box .el-form-item--default .el-form-item__content) {
        height: 200px;
        overflow: auto;
    }
</style>
